import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button } from "antd";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import destinationActions from "../../redux/destinationForm/actions";
import citiesActions from "../../redux/cities/actions";
import schedulesActions from "../../redux/schedules/actions";
import {
  dateStringToEpoch,
  displayScheduleDateFullNameFormat,
} from "../../utils/utility";
import sofiqImage from "../../images/sofia.jpg";
import skopjeImage from "../../images/skopje.jpg";
import kumanovoImage from "../../images/kumanovo.jpg";
import "./index.css";
import { useTranslation } from "react-i18next";

const PopularDestination = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { getSchedules, setUnlockSchedulesPage, getSchedulesTwoWay } =
    schedulesActions;
  const { getTripToCities } = citiesActions;

  const { cities } = useSelector((state) => state.citiesReducer);
  const { token, companies, selectedLanguage } = useSelector(
    (state) => state.mainReducer
  );
  const { destinationDate, destinationDateTwoWay } = useSelector(
    (state) => state.destinationReducer
  );
  const { setDestinationFrom, setDestinationTo } = destinationActions;

  const dayjsDate = dayjs(destinationDate.$d);

  // Get epoch timestamp in milliseconds
  const epochTimestamp = dayjsDate.valueOf();
  const epochTimestampInSeconds = Math.floor(epochTimestamp / 1000);

  const findCityId = (id) => {
    return cities?.find((city) => city.id === id);
  };

  const PopularDestinationArray = [
    {
      id: 1,
      fromImage: sofiqImage,
      toImage: skopjeImage,
      formText:
        selectedLanguage === "bg" ? findCityId(1).name : findCityId(1).nameLat,
      toText:
        selectedLanguage === "bg"
          ? findCityId(33).name
          : findCityId(33).nameLat,
      fromId: 1,
      toId: 33,
    },
    {
      id: 2,
      fromImage: skopjeImage,
      toImage: sofiqImage,
      formText:
        selectedLanguage === "bg"
          ? findCityId(33).name
          : findCityId(33).nameLat,
      toText:
        selectedLanguage === "bg" ? findCityId(1).name : findCityId(1).nameLat,
      fromId: 33,
      toId: 1,
    },
    {
      id: 3,
      fromImage: sofiqImage,
      toImage: kumanovoImage,
      formText:
        selectedLanguage === "bg" ? findCityId(1).name : findCityId(1).nameLat,
      toText:
        selectedLanguage === "bg"
          ? findCityId(34).name
          : findCityId(34).nameLat,
      fromId: 1,
      toId: 34,
    },
  ];

  return (
    <>
      <div className="popular-destination-container">
        <div className="popular-destination-heading-container">
          <p className="popular-destination-sub-heading">
            {displayScheduleDateFullNameFormat(epochTimestampInSeconds)}
          </p>
          <h1 className="popular-destination-main-heading">
            {t("popularDestination")}
          </h1>
        </div>
      </div>
      <section className="popular-destination-section">
        <div className="popular-destination-section-left popular-destination-section-area">
          {PopularDestinationArray.map((destinaiton) => {
            return (
              <div
                key={destinaiton.id}
                className="popular-destination-card-wrapper"
              >
                <div className="popular-destination-card-image-wrapper">
                  <div className="popular-destination-card-image-container">
                    <img
                      className="popular-destination-card-image-item"
                      src={destinaiton.fromImage}
                      alt="destinationFrom"
                    />
                    <img
                      className="popular-destination-card-image-item"
                      src={destinaiton.toImage}
                      alt="destionationTo"
                    />
                  </div>
                </div>
                <div className="popular-destination-card-info">
                  <div className="popular-destination-card-text big">
                    {destinaiton.formText} - {destinaiton.toText}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div>
                      <div className="popular-destination-card-text small">
                        {t("date")}
                        <span className="card-price">
                          {displayScheduleDateFullNameFormat(
                            epochTimestampInSeconds
                          )}
                        </span>
                      </div>
                    </div>
                    <Button
                      onClick={() => {
                        dispatch(setUnlockSchedulesPage(true));

                        dispatch(setDestinationFrom(destinaiton.fromId));
                        setTimeout(() => {
                          dispatch(setDestinationTo(destinaiton.toId));
                        }, 2000);

                        dispatch(
                          getSchedules(
                            token,
                            companies[0]?.id,
                            destinaiton.fromId,
                            destinaiton.toId,
                            dateStringToEpoch(
                              destinationDate.format("DD/MM/YYYY HH:mm")
                            )
                          )
                        );
                        dispatch(
                          getSchedulesTwoWay(
                            token,
                            companies[0].id,
                            destinaiton.toId,
                            destinaiton.fromId,
                            dateStringToEpoch(
                              destinationDateTwoWay.format("DD/MM/YYYY HH:mm")
                            )
                          )
                        );

                        dispatch(
                          getTripToCities(
                            token,
                            companies[0]?.id,
                            destinaiton.fromId,
                            dateStringToEpoch(
                              destinationDate.format("DD/MM/YYYY HH:mm")
                            )
                          )
                        );
                        navigate("/schedules");
                      }}
                      type="primary"
                      className="custom-button"
                    >
                      {t("select")}
                    </Button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>
      <div style={{ height: "90px" }}></div>
    </>
  );
};

export default PopularDestination;
